'use client';

import { ViewportProvider } from '@/components/core/contexts';
import { Toast } from '@/components/context/toast';
import { EventContext } from '@/components/context/events';
import { Analytics } from '@/components/context/analytics';
import configuration from '@/configuration';
import { LayoutProvider } from '@/components/context/layout';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useState } from 'react';
import { UTMType } from '@/@types';
import DownloadAppModal from '../download-app-modal';
import { Modals } from '../../molecules/modals/use-modal';

const LayoutContexts: React.FC<React.PropsWithChildren & { isBot?: boolean; isMobile?: boolean; utm?: UTMType }> = ({
  children,
  isBot = false,
  isMobile = false,
  utm = undefined,
}) => {
  const [queryClient] = useState(() => {
    return new QueryClient();
  });
  return (
    <QueryClientProvider client={queryClient}>
      <LayoutProvider utm={utm}>
        <Modals>
          <ViewportProvider ssrViewport={isMobile ? 'xs' : 'lg'}>
            {!isBot && <Analytics gtmId={configuration.gtm} />}
            <EventContext>
              <DownloadAppModal>
                <Toast>{children}</Toast>
              </DownloadAppModal>
            </EventContext>
          </ViewportProvider>
        </Modals>
      </LayoutProvider>
    </QueryClientProvider>
  );
};

export default LayoutContexts;
